import React from 'react';
import ReactDOM from 'react-dom';

import AppRouter from './App';
//import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';


import 'antd/dist/antd.css'/* Bug #473 @Author Jithin Kuriakose @Date 01 July 2021 */

    // boostrap
    import 'bootstrap/dist/css/bootstrap.min.css';
    //fontawesome
    import '../node_modules/font-awesome/css/font-awesome.min.css'; 
    import 'react-image-lightbox/style.css';
    import "react-datepicker/dist/react-datepicker.css";
    //carousel
    import "slick-carousel/slick/slick.css"; 
    import "slick-carousel/slick/slick-theme.css";


import { store } from './store';
import setupAxiosInterceptors from './config/axios-interceptor';
import { clearAuthentication } from './reducers/authenticationSlice';
import { configureStorage } from './config/storage';
import { Provider } from 'react-redux';
/**
 * Bug #461
 * @Author Anupama P
 * @Date 12 Jul 2021
 */
//import ServiceWorkerScripts from "pwa/ServiceWorkerScripts";
import * as firebaseServiceWorkerRegistration from './firebase/firebaseServiceWorkerRegistration';

/** End */


//ReactDOM.render(<AppRouter/>, document.getElementById('root'));


if(!window.location.pathname.includes("admin") || !window.location.pathname.includes("pharmacyadmin")) {
    
  //require('./client/assets/css/all.css')
  require('./client/assets/css/all.min.css')
  require('./client/assets/css/fontawesome.min.css')
  require('./client/assets/css/style.css')
  require('./client/assets/js/script.js')
}

configureStorage();
setupAxiosInterceptors(() => clearAuthentication('login.error.unauthorized'));
ReactDOM.render(
  <React.StrictMode>
    
    <Provider store={store}>
      <AppRouter />

    </Provider>
    {/* <ServiceWorkerScripts/> */}   {/* commented for hiding PWA Desktop */}
  </React.StrictMode>,
  document.getElementById('root')
);


// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
//serviceWorkerRegistration.register();
firebaseServiceWorkerRegistration.register();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()